import { render, staticRenderFns } from "./QPolicyTableStatFilter.vue?vue&type=template&id=d717c87c&"
import script from "./QPolicyTableStatFilter.vue?vue&type=script&lang=js&"
export * from "./QPolicyTableStatFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports